import { render, staticRenderFns } from "./BusInfoShopDataRecordsModal.vue?vue&type=template&id=c4a46a8c&"
import script from "./BusInfoShopDataRecordsModal.vue?vue&type=script&lang=js&"
export * from "./BusInfoShopDataRecordsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports